/**
 * @description 投保作業-資料填寫 step 1 交通工具選項用
*/
export enum Transport {
  /** 飛機 */
  Airplane = '1',
  /** 火車/高鐵 */
  Train = '2',
  /** 船/遊輪 */
  Ship = '3',
  /** 遊覽車 */
  TouristCar = '4',
  /** 其他 */
  Other = '99'
}
